//Importaciones
import i18next from 'i18next';
import React from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isNullUndefined } from '../../../../../../common/Helpers';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { useSelector } from 'react-redux';
import Loading from '../../../../../Templates/Site/Loading';


function CONSOLIDATE_GROUP_CONSOLIDATE_OPF(props) {
    //Helpers
    const { t } = useTranslation();

    const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
      inputParam_UseFake = false,
    } = props;

	const { 
		_opfData: opfData,
		_fireLoading: fireLoading,
	} = useSelector((state) => state.compareContractsScope);

    const renderContent = () => {
      	return  <>
					{
						!fireLoading &&
						<>
							{
								!isNullUndefined(opfData) &&
								<>
									<Row className='text-center p-0 m-0'>
										<Col className='py-4' style={{ fontSize: "21px", backgroundColor: "#0A487C", color: "white" }}>{t('data-lang-lbl-monthlyopf')}</Col>
									</Row>
									<Row className='text-center' style={{ fontSize: "43px" }}>
										<Col>{ (!isNullUndefined(opfData.scopeValue) ? `${ parseFloat(opfData.scopeValue.toFixed(2)).toLocaleString(i18next.language) }%` : 'S/D') }</Col>
									</Row>
									<Row className='text-center'>
										<Col>{t('data-lang-lbl-acumopfvalue')}</Col>
									</Row>
								</>
							}
							{
								isNullUndefined(opfData) &&
								<span>{t('data-lang-msg-selectcontractandpillartocontinue')}</span>
							}
						</>
					}
					{
						fireLoading &&
						<Loading
							inputParam_Style={{marginTop: 0}}
							inputParam_Width = '30px'
							inputParam_Height = '30px'
						/>
					}
                </>
    }

    //Render de componente.
    return (
		<>
			{
				!inputParam_UseFake &&
				<Card className='h-100'>
					{
						!inputParam_HideHeader &&
						<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									<b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-group_consolidated_opf')) : t('data-lang-boxname-group_consolidated_opf')}</b>
									<div className='toolbar d-flex'>

									</div>
								</Card.Title>
						</Card.Header>
					}
					<Card.Body className={`h-100 p-0 m-0${isNullUndefined(opfData) ? ' text-center d-flex justify-content-center align-items-center' : ''}`}>
						{ renderContent() }
					</Card.Body>
				</Card>
			}
			{ inputParam_UseFake && renderContent() }
		</>
    );
}

CONSOLIDATE_GROUP_CONSOLIDATE_OPF.propTypes = {
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default CONSOLIDATE_GROUP_CONSOLIDATE_OPF;